import { errorMessage } from '@/lib/helpers/error-messages'

export default {
  computed: {
    /**
     * Find all the fields within our page(s)
     *
     * @returns {array}
     */
    getFields() {
      // If we're dealing with a single level page, return the fields
      if (this.page.fields) {
        return this.page.fields
      }

      // Otherwise, loop through each page and grab the fields
      return Object.keys(this.page).reduce((fields, key) => {
        const current = this.page[key].fields

        if (current) {
          fields.push(...current)
        }

        return fields
      }, [])
    },

    /**
     * Re-format the nested fields so we can grab them by ID and
     * apply some Vuelidate validation messages.
     */
    fields() {
      return this.getFields.reduce((fields, { input }) => {
        if (!input || !input.id) {
          return
        }

        const vPath = this.vPath || this.$v
        const v = vPath?.[input.id] || {}

        fields[input.id] = {
          ...this.getValidation(input, v),
          ...input,
        }

        return fields
      }, {})
    },
  },

  methods: {
    getValidation(input, v) {
      const message = errorMessage(v, input.field_name)

      let status = null

      if (v.$error) {
        status = 'error'
      } else if (v.$dirty && !v.$error) {
        // status = 'success'
      }

      return { status, message }
    },
  },
}
